
export default "/assets/paint-brush-micro.336586f0.svg"